// extracted by mini-css-extract-plugin
export default {"root":"Jury_root__JqHhx","container":"Jury_container__9Uc36","list":"Jury_list__ggE+c"};